export const getInvalidRequiredFields = (requiredFields, fieldValidity) =>
  requiredFields.filter((field) => fieldValidity[field] !== true);

export const markFieldError = (field, wrapperMap, fieldConfig) => {
  const wrapper = document.querySelector(wrapperMap[field]);
  if (wrapper) wrapper.classList.add('has-error');

  const errorEl = fieldConfig[field]?.errorTarget
    ? document.querySelector(fieldConfig[field].errorTarget)
    : null;
  if (errorEl && !errorEl.textContent.trim()) {
    errorEl.textContent = 'Required';
    errorEl.dataset.injected = 'true';
  }
};

export const syncFieldError = (field, wrapperMap, fieldConfig, hasError) => {
  const wrapper = document.querySelector(wrapperMap[field]);
  if (wrapper) wrapper.classList.toggle('has-error', !!hasError);
  if (hasError) return;

  const errorEl = fieldConfig[field]?.errorTarget
    ? document.querySelector(fieldConfig[field].errorTarget)
    : null;
  if (errorEl && errorEl.dataset.injected === 'true') {
    errorEl.textContent = '';
    delete errorEl.dataset.injected;
  }
};
